import { render, staticRenderFns } from "./About_us.vue?vue&type=template&id=4fd1e2b7&scoped=true"
import script from "./About_us.vue?vue&type=script&lang=js"
export * from "./About_us.vue?vue&type=script&lang=js"
import style0 from "./About_us.vue?vue&type=style&index=0&id=4fd1e2b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd1e2b7",
  null
  
)

export default component.exports